import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WidgetsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"widgets"}/>
}
